import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { MarketingVoucherPresenter } from "./presenter";
import * as Shared from "../../_shared";

type Props = {
	hotelID: string;
};

export const MarketingVoucherContainer = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(Shared.Repository.Query.Schema.VoucherListByHotelID_TopPage_Query, {
		variables: { hotelID },
	});

	return <MarketingVoucherPresenter hotelID={hotelID} data={data} />;
};

MarketingVoucherContainer.displayName = "MarketingVoucherContainer";
